// Garde-fou contre un verrou Radix orphelin (01/10, remarque de Louka : « plus aucun clic ne
// répond, un rechargement remet tout en ordre »). Une boîte, une feuille ou un menu modal pose
// `body { pointer-events: none }` tant qu'il est ouvert. Quand deux de ces calques se démontent en
// même temps (une navigation lancée depuis un élément de menu, une feuille fermée depuis un menu),
// Radix peut oublier de retirer le verrou : plus aucun calque, mais plus aucun clic non plus.
// Ici : dès qu'un calque disparaît du document (observateur) ou au prochain clic, si le body est
// verrouillé sans plus aucun calque ouvert, le verrou est levé.

const SELECTEUR_CALQUE = [
  '[role="dialog"][data-state="open"]',
  '[role="alertdialog"]',
  '[role="menu"]',
  "[data-radix-popper-content-wrapper]",
  "[data-radix-menu-content]",
].join(", ");

export function corpsVerrouilleSansCalque(doc: Document): boolean {
  return (
    doc.body?.style.pointerEvents === "none" &&
    doc.querySelector(SELECTEUR_CALQUE) === null
  );
}

export function leverLeVerrouSiOrphelin(doc: Document): boolean {
  if (!corpsVerrouilleSansCalque(doc)) {
    return false;
  }
  doc.body.style.pointerEvents = "";
  return true;
}

export function installerLeDeverrouillage(doc: Document): () => void {
  const lever = () => {
    leverLeVerrouSiOrphelin(doc);
  };
  // Capture : le body verrouillé n'est plus une cible, l'événement part de <html>.
  doc.addEventListener("pointerdown", lever, true);
  let observateur: MutationObserver | null = null;
  if (typeof MutationObserver !== "undefined" && doc.body) {
    observateur = new MutationObserver(lever);
    observateur.observe(doc.body, { childList: true });
  }
  return () => {
    doc.removeEventListener("pointerdown", lever, true);
    observateur?.disconnect();
  };
}
